"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconText = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var provider_1 = require("../../../theme/provider");
var utils_1 = require("../../../utils/utils");
var StyledText = (0, styled_components_1.default)("p")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  margin: ", ";\n  font-family: ", ";\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: ", ";\n\n  .icon {\n    width: 18px;\n    height: 18px;\n    display: flex;\n    align-items: center;\n    margin-right: 9px;\n\n    svg {\n      flex-shrink: 0;\n      fill: ", ";\n    }\n  }\n  .text {\n    width: 100%;\n  }\n"], ["\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  margin: ", ";\n  font-family: ", ";\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: ", ";\n\n  .icon {\n    width: 18px;\n    height: 18px;\n    display: flex;\n    align-items: center;\n    margin-right: 9px;\n\n    svg {\n      flex-shrink: 0;\n      fill: ", ";\n    }\n  }\n  .text {\n    width: 100%;\n  }\n"])), function (_a) {
    var noMargin = _a.noMargin;
    return (noMargin ? "0" : "0 0 20px 0");
}, function (props) { return (0, provider_1.getFontFromTheme)(props.theme).fontFamily; }, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.white, theme.gray1);
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.white, theme.black);
});
var IconText = function (props) {
    var _a;
    var text = props.text, icon = props.icon, styles = props.styles, _b = props.className, className = _b === void 0 ? "" : _b;
    return ((0, jsx_runtime_1.jsxs)(StyledText, __assign({ className: "wellms-component ".concat(className) }, props, { children: [icon && ((0, jsx_runtime_1.jsx)("span", __assign({ className: "icon", style: styles === null || styles === void 0 ? void 0 : styles.icon, role: "button", "aria-label": typeof text === "string" ? text : (_a = text === null || text === void 0 ? void 0 : text.props) === null || _a === void 0 ? void 0 : _a.children }, { children: icon }))), (0, jsx_runtime_1.jsx)("div", __assign({ className: "text", style: styles === null || styles === void 0 ? void 0 : styles.text }, { children: text }))] })));
};
exports.IconText = IconText;
var NewComponent = (0, styled_components_1.default)(exports.IconText)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.default = (0, styled_components_1.withTheme)(NewComponent);
var templateObject_1, templateObject_2;
